import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type FacebookProps = Omit<BusinessIconImageProps, 'color' | 'strokeWidth'>;

const Facebook = forwardRef<SVGSVGElement, FacebookProps>(
  ({ size = 24, width, height, alt = '', style, ...props }, ref) => (
    <svg
      ref={ref}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={style}
      {...props}
    >
      <g transform="translate(0.249996 0.247035) scale(0.419643)">
        <g clipPath="url(#clip0_4129_5565)">
          <path mask="url(#mask0_facebook)" d="M56 28.0071C56 12.5443 43.4628 0.0071106 28 0.0071106C12.5372 0.0071106 0 12.5443 0 28.0071C0 41.9815 10.2377 53.5658 23.6254 55.6685V36.1027H16.5141V28.0071H23.6254V21.837C23.6254 14.8202 27.8071 10.9417 34.2017 10.9417C37.2651 10.9417 40.4703 11.489 40.4703 11.489V18.3798H36.9383C33.4614 18.3798 32.3746 20.5376 32.3746 22.7544V28.0071H40.1395L38.8992 36.1027H32.3746V55.6685C45.7623 53.5698 56 41.9855 56 28.0071Z" fill="#1977F3" />
        </g>
        <defs>
          <clipPath id="clip0_4129_5565">
            <rect width="56" height="56" fill="white" />
          </clipPath>
          <mask id="mask0_facebook" maskUnits="userSpaceOnUse" x="0" y="0" width="56" height="56">
            <rect width="56" height="56" fill="white" />
            <path d="M38.8992 36.1027L40.1395 28.007H32.3747V22.7543C32.3747 20.5414 33.4575 18.3797 36.9383 18.3797H40.4703V11.489C40.4703 11.489 37.2651 10.9416 34.2017 10.9416C27.8071 10.9416 23.6254 14.8162 23.6254 21.8369V28.007H16.5142V36.1027H23.6254V55.6684C25.0508 55.8928 26.5116 56.007 28 56.007C29.4884 56.007 30.9493 55.8889 32.3747 55.6684V36.1027H38.8992Z" fill="black" />
          </mask>
        </defs>
      </g>
    </svg>
  ),
);

Facebook.displayName = 'Facebook';

export default Facebook;
